<template>
  <div class="one-product-actions one-cms-grid-renderer one-product-tile-right-actions border-bottom-xs py-2 actions-container fetis_product_buybox_actions" type="productActions">
    <div class="col">
      <div class="d-flex justify-content-end align-items-center">
        <template v-if="inContainer">
          <div class="input-container px-1">
            <div class="one-content-unit">
              <div role="group" class="input-group">
                <input type="number" v-model="orderValue" :min="quantityInterval" :step="quantityInterval" class="one-content-unit__input form-control" @change="onOrderValChange">
              </div>
              <div class="one-content-unit__unit one-input-tooltip__unit">{{ orderUnitDescription }}</div>
            </div>
          </div>
          <p class="pb-1">=</p>
        </template>
        <div class="input-container px-1">
          <div class="one-input-tooltip">
            <input type="number" v-model="orderQuantity" min="1" step="1" class="one-input-tooltip__input form-control" @change="onOrderQtyChange">
            <div class="one-input-tooltip__unit">{{ contentUnitDescription }}</div>
          </div>
        </div>
        <button type="button" class="btn btn-secondary" :disabled="submitting" @click="submit">
          <div class="btn-content">
            <div>
              Kosárba
              <i class="ml-1 icon-ecommerce-cart-download"></i>
            </div>
          </div>
        </button>
      </div>
      <div class="d-flex justify-content-end align-items-center">
        <div class="one-quantity-and-interval-info__container">
        </div>
      </div>
    </div>
  </div>
</template>

<style>

div {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

.one-input-tooltip__unit {
  font-size: .7em;
}

.one-content-unit, .one-input-tooltip {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

input.form-control {
  height: auto !important;
  max-width: 90px !important;
  padding: 2px !important;
  text-align: center !important;

  border: 1px solid #ced4da !important;
  border-radius: 0.25rem !important;
}

button.btn {
  padding: 5px 2px;
  text-transform: uppercase;
  background-color: #1D71B8 !important;
  background: #1D71B8 !important;
  border-color: #1D71B8 !important;
  color: #FFF !important;
  border-radius: 4px;
  transition: all 300ms ease;
}

button.btn.btn-secondary {
  padding-left: 0.5rem !important;
}

.btn:hover {
  background: #1F2F51 !important;
  border-color: #1F2F51 !important;
  color: #fff !important;
}

.btn-secondary:hover {
  background: #1F2F51;
  color: #fff;
}

.btn-content {
  font-family: 'Montserrat';
  font-style: normal;
  font-size: .7rem;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.03em;
  color: #FFFFFF;
}

.icon-ecommerce-cart-download {
  font-size: 20px;
  vertical-align: sub;
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

</style>

<script>
export default {
  name: "AddToCartComponent",
  props: ["product", "onSubmit", "quantity"],
  computed: {
    inContainer() {
      return this.quantityInterval > 1.0;
    },
    quantityInterval() {
      //return 3.0;
      return this.product.measurementUnits.packingQuantity;
    },
    orderUnitDescription() {
      //return "(Darab)";
      return this.product.measurementUnits.contentUnitDescription;
    },
    contentUnitDescription() {
      //return "(Doboz)";
      return this.product.measurementUnits.orderUnitDescription;
    }
  },
  methods: {
    onOrderValChange() {
      this.orderValue = parseFloat(this.orderValue);
      this.orderQuantity = Math.ceil(this.orderValue / this.quantityInterval);
      this.orderValue = this.orderQuantity * this.quantityInterval;
    },
    onOrderQtyChange() {
      this.orderQuantity = parseFloat(this.orderQuantity);
      this.orderValue = this.orderQuantity * this.quantityInterval;
    },
    submit() {
      this.submitting = true;
      let promise = this.onSubmit();
      if (promise) {
        promise.finally(() => {
          this.submitting = false;
        });
      }
    }
  },
  data() {
    return {
      /** @type {import('@one-commerce/sdk-shop-vue3').VueSdk} */
      $one: null,
      orderQuantity: this.quantity,
      orderValue: this.quantity.value * this.product.measurementUnits.packingQuantity,
      submitting: false,
    };
  },
  watch: {
    orderQuantity() {
      this.onOrderQtyChange();
    }
  }
}
</script>